import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import { log, error } from '@/services/Log'

export const initializeOrderConfirmation = async () => {
  log('Initialize OrderConfirmationPage')
  try {
    const [
      { getFinalizedOrder },
      { getCustomer },
      { getBranding },
    ] = await allPromisesWithRetries(() => [
      import('@/services/FramedCheckout/orderServices/getFinalizedOrder'),
      import('@/services/FramedCheckout/customerServices'),
      import('@/services/FramedCheckout/getBranding'),
    ])
    const [
      order,
      branding,
      customer,
    ] = await Promise.all([
      getFinalizedOrder({
        orderId: String(window.location.pathname.split('/').pop()),
      }),
      getBranding({
        stripe: null,
        stripeApplePayRequest: null,
      })(),
      getCustomer(),
    ])
    return {
      success: true, order, branding, customer,
    }
  } catch (err) {
    error(`Failed to initialize order confirmation  page:\t ${err}`, { error: err })
    const { goToCart } = await import('@/services/FramedCheckout/navigationServices')
    await goToCart()
    return { success: false }
  }
}

export default initializeOrderConfirmation
